module.exports = __webpack_public_path__ + "static/img/10032B_2_R_20200402_LC.46d11c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10032B_2_R_20200402_LC.png
// module id = SEsy
// module chunks = 0